if (!customElements.get('quantity-breaks')) {
  class QuantityBreaks extends HTMLElement {
    connectedCallback() {
      this.tiles = Array.from(this.querySelectorAll('.quantity-breaks__tile'));
      const quantityInputId = this.dataset.quantityInputId;
      this.quantityInput = quantityInputId ? document.getElementById(quantityInputId) : null;

      this.tiles.forEach((tile) => {
        tile.addEventListener('click', () => this.select(tile));
        tile.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.select(tile);
          }
        });
      });
    }

    select(tile) {
      this.tiles.forEach((t) => {
        const active = t === tile;
        t.classList.toggle('quantity-breaks__tile--active', active);
        t.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      const qty = parseInt(tile.dataset.qty, 10) || 1;

      if (this.quantityInput) {
        this.quantityInput.value = qty;
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      this.dispatchEvent(
        new CustomEvent('quantity-breaks:select', {
          bubbles: true,
          detail: { quantity: qty, total: tile.dataset.total },
        })
      );
    }
  }

  customElements.define('quantity-breaks', QuantityBreaks);
}
